export default "__VITE_ASSET__BXj5NJ$G__"